module.exports = __webpack_public_path__ + "static/img/logo.a2f1710a.svg";